<template>
    <div class="KM-table">
        <el-table
            ref='tableListRef'
            :key="itemKey"
            :data='k_tableList'
            :header-cell-style="{background:'#a7754f',color:'#fff'}"
            size='mini'
            row-key="id"
            border
            default-expand-all
            @sort-change="sort_change"
            style="width: 100%">
            <el-table-column
                label="NO"
                sortable
                align="center"
                prop="num"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="name"
                sortable
                label="名称">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                prop="pinCi"
                label="频次">
            </el-table-column>
        </el-table>
        <el-pagination 
            size='small'
            class="page-wrap"  
            @current-change="changePage" 
            @size-change="sizeChange"
            background
            :current-page="k_pageInfo.pageNum" 
            :page-count="k_pageInfo.pageTotal" 
            :page-size="k_pageInfo.pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="k_pageInfo.total"
            layout="total, sizes, prev, pager, next, jumper" >
        </el-pagination>
    </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex'
export default {
    data () {
        return {
            column:{},
            itemKey:Math.random()
            // tableList:[],
            // KM_table:[],
            // k_pageInfo: {
            //     pageNum: 1,
            //     pageTotal: 1,
            //     total: 1,
            //     pageSize: 10,
            // },
        }
    },
    computed: {
        ...mapState({
            k_tableList:state=>state.excavate.k_tableList,
            k_table:state=>state.excavate.k_table,
            k_pageInfo:state=>state.excavate.k_pageInfo,
        })
        
    },
    mounted() {
       
    },
    methods: {
        // 恢复默认排序
        clearSort(){
            this.$refs.tableListRef.clearSort();
        },
        changePage(num) {
            this.$store.state.excavate.k_pageInfo.pageNum=num;
            this.$store.state.excavate.k_tableList= this.k_table.slice((this.k_pageInfo.pageNum-1)*this.k_pageInfo.pageSize,this.k_pageInfo.pageNum*this.k_pageInfo.pageSize);
            // }
        },
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column;
            // sizeChange
            this.$store.state.excavate.total = this.k_table.length
            this.$store.state.excavate.k_table = this.k_table.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        // 每页条数
        sizeChange(val) {
            this.$store.state.excavate.k_pageInfo={
                pageSize:val,
                total:this.k_pageInfo.total,
                pageTotal:Math.ceil(this.k_pageInfo.total/val),
                pageNum:this.k_pageInfo.pageNum,
            }
            this.changePage(1)
            this.$store.state.excavate.k_pageInfo.pageSize=val;
        },

    }
}
</script>

<style>

</style>